module.exports = __webpack_public_path__ + "media/images/icon-like-off@3x-6fe1709149a566216ef4e69f85f63913.png";